import {
  format,
  isToday,
  isTomorrow,
  parse,
} from 'date-fns'
import { ru } from 'date-fns/locale'
import getFirstLetterUpper from 'common/utils/getFirstLetterUpper'
import type { ScheduleDayItem } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/types'

/**
 * Дни календаря записи из карты слотов.
 *
 * Подряд идущие пустые дни схлопываются в диапазон («27 фев – 3 мар»).
 */
export default function getDateItemsFromSlots(
  slots: Record<string, unknown[]>,
  locale = ru,
): ScheduleDayItem[] {
  const items = Object.entries(slots).map(([date, daySlots]) => {
    const dateParsed = parse(date, 'yyyy-MM-dd', new Date())
    let label = ''

    if (isToday(dateParsed)) {
      label = 'Сегодня'
    } else if (isTomorrow(dateParsed)) {
      label = 'Завтра'
    }

    return {
      date,
      title: format(dateParsed, 'd MMM', { locale }).replace('.', ''),
      subtitle: getFirstLetterUpper(format(dateParsed, 'EEEEEE', { locale })),
      label,
      disabled: !daySlots.length,
    }
  })

  return items.reduce<ScheduleDayItem[]>((result, currentItem, currentIndex) => {
    if (!currentIndex) {
      result.push(currentItem)

      return result
    }

    if (!currentItem.disabled) {
      result.push(currentItem)

      return result
    }

    const nextItem = items[currentIndex + 1]
    const lastAddedItem = result[result.length - 1]

    if (nextItem?.disabled) {
      if (!lastAddedItem.disabled) {
        result.push(currentItem)
      }

      return result
    }

    if (lastAddedItem.disabled) {
      mergeDisabledDayRange(lastAddedItem, currentItem)

      return result
    }

    result.push(currentItem)

    return result
  }, [])
}

function mergeDisabledDayRange(previous: ScheduleDayItem, current: ScheduleDayItem) {
  const [firstDay, firstMonth] = previous.title.split(' ')
  const [, secondMonth] = current.title.split(' ')

  previous.title = firstMonth === secondMonth
    ? `${firstDay}–${current.title}`
    : `${previous.title} – ${current.title}`
  previous.subtitle = `${previous.subtitle}–${current.subtitle}`
  previous.label = ''
}
